import React, { Component } from "react";

import Layout from "../layouts/en";
import SEO from "../components/seo";
import SignUp from "../services/SignUp";
import SignUpLang from "../data/static-pages/pages/signup/en";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { loadState, saveState } from "../state/utils/localStorage";
import { navigate } from "gatsby";
import moment from "moment";
import { isLoggedIn } from "../services/Auth";

const isAuth0Enabled = process.env.GATSBY_ENABLE_AUTH0 === "true";

class SignUpPage extends Component {
  constructor(props, context) {
    super(props, context);

    this.urlRedirect = "/verify-account";
    this.termsUrl = "/terms-and-conditions-8";
    this.langKey = this.props.pageContext.langKey;
  }

  componentDidMount() {
    if (isAuth0Enabled) {
      navigate("/member");
      return;
    }
    if (isLoggedIn()) {
      navigate("/member");
    }
  }

  static getLoginOptions() {
    // Check if window is defined before accessing it
    const referral =
      typeof window !== "undefined" &&
      new URLSearchParams(window.location.search).get("referral");
    const redirectUri =
      typeof window !== "undefined" && `${window.location.origin}/callback`;

    return {
      loginOptions: {
        authorizationParams: {
          screen_hint: "signup",
          ui_locales: "en",
          referral,
          redirect_uri: redirectUri,
        },
      },
    };
  }

  render() {
    if (isAuth0Enabled) {
      return null;
    }
    return (
      <Layout location={this.props.location}>
        <SEO title="Sign Up " keyword="Sign Up" decription="Sign Up" />

        <SignUp
          location={this.props.location}
          urlRedirect={this.urlRedirect}
          langData={SignUpLang}
          langKey={this.langKey}
          termsUrl={this.termsUrl}
        />
      </Layout>
    );
  }
}

export default isAuth0Enabled
  ? withAuthenticationRequired(SignUpPage, SignUpPage.getLoginOptions())
  : SignUpPage;
